
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './ProjectWizardV2Base.html?raw';
import '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/Floating/Menu";
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { ProjectWizardContactPersonSelector } from "../../_loadingHelpers/VAMv2";
import { VAM2types } from "../../_loadingHelpers/VAMv2Types";
import SearchSelect from '../../../moreCore/UI/SearchSelect/SearchSelect';
import { rgbaToHex } from "../../../moreCore/Tools/RgbaToHex";
import DateTimeInput from '../../../moreCore/UI/DateTimeInput/DateTimeInput';

class ProjectWizardV2Base extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private isPeriod: boolean = false;
    private sectionPeriodDates: HTMLDivElement;
    private sectionDateFrom: HTMLDivElement;
    private sectionDateTo: HTMLDivElement;
    private inputDateFrom: MdsLax<InstanceType<typeof DateTimeInput>>;
    private inputDateTo: MdsLax<InstanceType<typeof DateTimeInput>>;


    private projectType: MdsLax<InstanceType<typeof SearchSelect>>;

    private existingEntity: VAM2types.EvProjectEntity_Base = null;

    private contactPersonSelectorForm: MdsLax<InstanceType<typeof ProjectWizardContactPersonSelector>>;
    private promoter1SelectorForm: MdsLax<InstanceType<ReturnType<typeof _StatefulSection>>>;

    private artisticPeriod: MdsLax<InstanceType<typeof SearchSelect>>;
    private financialPeriod: MdsLax<InstanceType<typeof SearchSelect>>;

    setIsPeriod(isPeriod: boolean): void {
        this.isPeriod = isPeriod;
        this.projectType.setReadonly(isPeriod);
        if (this.hasFeature("EvProject/PeriodProject") && this.sectionPeriodDates) this.hideNode(this.sectionPeriodDates, !isPeriod);
        if (this.hasFeature("EvProject/PeriodProject") && this.sectionDateFrom) this.hideNode(this.sectionDateFrom, !isPeriod);
        if (this.hasFeature("EvProject/PeriodProject") && this.sectionDateTo) this.hideNode(this.sectionDateTo, !isPeriod);
    }

    private _getProjectTypePeriodID(): string {
        let projectTypePeriodID: string;

        let module: { projectTypePeriodID: string } = this.getModule("EvProject");
        projectTypePeriodID = module.projectTypePeriodID;

        return projectTypePeriodID;
    }

    afterSetData() {
        let data = this.sourceData as VAM2types.EvProjectEntity_Base;

        this.setIsPeriod(data.ref_ev_project_type_2 && data.ref_ev_project_type_2.ID === this._getProjectTypePeriodID() ? true : false);

        if (data.ID) {
            this.webPrivilegeManager.loadPrivilegesForEntity(data, lang.hitch(this, this._onPrivilegesLoaded));
            this.existingEntity = data;

        } else {
            this._onPrivilegesLoaded();
            this.projectType.autosetSingleValue("strict");
        }

        if (data?.ev_project_name) {
            this.emit("displayname", data.ev_project_name);
        }

        if (this.getAttributeValue("ref_promoter_1")) {
            this.disableNode(this.contactPersonSelectorForm, false);
        }

        this.setStartupState("ready");
    }

    _onPeriodSelectLoaded(searchSelect: MdsLax<InstanceType<typeof SearchSelect>>) {
        let periods = searchSelect.getAllValues();
        for (let period of periods) {
            let date = new Date(period["entity"].date_start);
            if (date.getFullYear() === new Date().getFullYear()) {
                let style = getComputedStyle(document.documentElement);
                let cssVar = style.getPropertyValue("--primaryTransparent");
                let hexColor = rgbaToHex(cssVar);
                period["bgColor"] = hexColor;
                searchSelect.refreshOptions();
            } else {
                let style = getComputedStyle(document.documentElement);
                let cssVar = style.getPropertyValue("--complimentaryThemeTransparent");
                let hexColor = rgbaToHex(cssVar);
                period["bgColor"] = hexColor;
                searchSelect.refreshOptions();
            }
        }

        let projectTypePeriodID = this._getProjectTypePeriodID();
        if (!this.sourceData && this.isPeriod) this.projectType.setValue(projectTypePeriodID);
    }

    onDirtyChange(currentState: boolean) {
        
    }

    _onChanged(key: string, value: any) {
        //console.trace(this.id + " _onChanged:", key, value);

        switch (key) {
            case "date_from":
                var offset = this.inputDateFrom?.getValue()?.date?.getTimezoneOffset();
                this.setAttributeValue("date_from_offset", -offset);

                let date_to = this.getAttributeValue("date_to");
                if (!date_to) this.inputDateTo.setValue(value);
                break;
            case "date_to":
                console.log(value);

                var offset = this.inputDateTo?.getValue()?.date?.getTimezoneOffset();
                this.setAttributeValue("date_to_offset", -offset);
                break;
        }
    }

    _onChangePromoter(e: Event) {
        let currentValue: VAM2types.EvProject_PromoterEntity = this.promoter1SelectorForm.getChangedData();
        if (currentValue) {
            this.disableNode(this.contactPersonSelectorForm, false);
            this.contactPersonSelectorForm.setData(currentValue);
            this.contactPersonSelectorForm.setNullValue()

        } else {
            this.contactPersonSelectorForm.setNullValue()
            this.disableNode(this.contactPersonSelectorForm, true);
        }
    }

    private _onChanged_EvProjectName(key: string, newValue: string, oldValue: string) {
        if (newValue) {
            this.emit("displayname", newValue);
        }
    }
    private _onChanged_ArtisticPeriod(key: string, newValue: VAM2types.ArtisticPeriod, oldValue: string) {
        if (this.startupState == "ready") {
            if (newValue) {
                if (newValue.ref_financial_period) {
                    this.setAttributeValue("ref_financial_period", newValue.ref_financial_period);
                }
            }
        }
    }

    private _onPrivilegesLoaded() {
        if (!this.hasFeature("EvProject/UsePromoter1Contactperson")) {
            this.hideNode(this.contactPersonSelectorForm, true);
        }
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.disableNode(this.contactPersonSelectorForm, true);

        this.addOnchanged("ev_project_name", lang.hitch(this, this._onChanged_EvProjectName));
        this.addOnchanged("ref_artistic_period", lang.hitch(this, this._onChanged_ArtisticPeriod));

        this.artisticPeriod.on("loaded", lang.hitch(this, this._onPeriodSelectLoaded, this.artisticPeriod));
        this.financialPeriod.on("loaded", lang.hitch(this, this._onPeriodSelectLoaded, this.financialPeriod));
        this.domNode.setAttribute("data-cy", "DivProjectWizard");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(ProjectWizardV2Base);
